module.exports = __webpack_public_path__ + "img/5.592cdb5e.jpeg";